import { render, staticRenderFns } from "./tableIcon.vue?vue&type=template&id=1f828aed&scoped=true&"
import script from "./tableIcon.vue?vue&type=script&lang=js&"
export * from "./tableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f828aed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f828aed')) {
      api.createRecord('1f828aed', component.options)
    } else {
      api.reload('1f828aed', component.options)
    }
    module.hot.accept("./tableIcon.vue?vue&type=template&id=1f828aed&scoped=true&", function () {
      api.rerender('1f828aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableIcon.vue"
export default component.exports